<template>
    <!-- Left side column. contains the logo and sidebar -->
    <aside class="main-sidebar">
        <!-- sidebar: style can be found in sidebar.less -->
        <section class="sidebar">
            <!-- Sidebar user panel (optional) -->
            <div class="user-panel mb10" style="padding-top: 40px;">
                <div class="image">
                    <img src="@/static/images/logo.png" class="img-responsive center-block " alt="" style="width: 110px;max-width: 110px;">
                </div>
            </div>
            <!-- Sidebar Menu -->
            <ul class="sidebar-menu" data-widget="tree">
                <li v-for="(item,index) in sidebarList" :key="item.key" @click="handleNav(item,index)" 
                :class="[item.children.length?'treeview':'',index===currentIndex?'active':'']">
                    <router-link :to="item.link">
                        <i :class="['fa',item.icon]"></i>&nbsp;<span>{{item.title}}</span>
                        <i v-if="item.children.length" class="fa fa-angle-left pull-right"></i>
                    </router-link>
                    <ul v-if="item.children.length" class="treeview-menu">
                        <li v-for="(citem,cindex) in item.children" v-show="!(citem.link=='/system/role'&& user.role != 1)  " :key="citem.key" @click="handleLevel(cindex)"
                         :class="cindex+1===currentLevel?'level-active':''">
                            <router-link :to="citem.link" class="ml20"> <span>{{citem.title}}</span></router-link>
                        </li>
                    </ul>
                </li>
            </ul>
            <!-- /.sidebar-menu -->
        </section>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
    export default {
        name: 'sidebar',
        data() {
            return {
                user:{},
                currentIndex: 0,
                currentLevel: 0,
                sidebarList: [{
                    icon: 'fa-home',
                    title: '首页',
                    link: '/statistics',
                    children: []
                }, {
                    icon: 'fa-asterisk',
                    title: '公众号管理',
                    link: '/wechat/list',
                    children: []
                }, {
                    icon: 'fa-tags',
                    title: '产品管理',
                    link: '/product',
                     children: []
                }, {
                    icon: 'fa-bar-chart',
                    title: '运营管理',
                    link: '/business/list',
                    children: [{
                        title: '收费规则',
                        link: '/business/chargeRole'
                    }, {
                        title: '信息列表',
                        link: '/business/message'
                    }, {
                        title: '充值查询',
                        link: '/business/recharge'
                    }, {
                        title: '订单查询',
                        link: '/business/order'
                    }]
                }, {
                    icon: 'fa-user',
                    title: '用户管理',
                    link: '/user/index',
                    children: []
                }, {
                    icon: 'fa-cog',
                    title: '系统管理',
                    link: '/system/setting',
                    children: [{
                        title: '账户管理',
                        link: '/system/account'
                    },{
                        title: '权限设置',
                        link: '/system/role'
                    },{
                        title: '设备类型',
                        link: '/device_type'
                    },{
                        title: '商品列表',
                        link: '/shop/product'
                    },{
                        title: '服务网点',
                        link: '/service/list'
                    }]
                }]
            }
        },
      
        methods: {
            // 一级目录样式切换
            handleNav(item, index) {
                this.currentIndex = index;
                localStorage.setItem('navIndex', this.currentIndex);
                if (!item.children.length) {
                    this.currentLevel = 0;
                    localStorage.removeItem('levelIndex');
                }
            },
            // 二级目录样式切换
            handleLevel(index) {
                this.currentLevel = index + 1;
                localStorage.setItem('levelIndex', this.currentLevel);
            }
        },
        mounted() {
             let user = window.window.sessionStorage.user;
            user = user && JSON.parse(user);
            console.log(user)
            this.user = user;
            if (localStorage.getItem('navIndex')) {
                this.currentIndex = parseInt(localStorage.getItem('navIndex'));
            }
            if (localStorage.getItem('levelIndex')) {
                this.currentLevel = parseInt(localStorage.getItem('levelIndex'));
            }
        }
    }
</script>

<style lang="scss" scoped>
    .level-active {
        a {
            color: #fff !important;
        }
    }
</style>
